import { render, staticRenderFns } from "./FileAClaim.vue?vue&type=template&id=2fc1ea78"
import script from "./FileAClaim.vue?vue&type=script&lang=js"
export * from "./FileAClaim.vue?vue&type=script&lang=js"
import style0 from "./FileAClaim.vue?vue&type=style&index=0&id=2fc1ea78&prod&lang=stylus&module=attr"




function injectStyles (context) {
  
  this["attr"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HeaderTemplate: require('/var/www/malayan/web/components/global/templates/HeaderTemplate.vue').default,ButtonTemplate: require('/var/www/malayan/web/components/global/templates/ButtonTemplate.vue').default})
